import { MAX_FILE_SIZE } from '@/platform';
import { formatters } from '@/core';
import { Typography } from 'antd';
import React, { useRef } from 'react';
import classNames from 'classnames';
import { notify } from '../Notify';
import { useTranslation } from 'react-i18next';
import { UploadOutlined } from '@ant-design/icons';
import { AttachedExcel } from './AttachedExcel';
import classes from './AttachExcel.module.scss';

function validate(file: File, accept: string): boolean {
  if (file.size > MAX_FILE_SIZE) {
    notify.error.t('projects.project.uploadFile.fileTooLarge', {
      maxSize: formatters.fileSize(MAX_FILE_SIZE),
    });
    return false;
  }

  if (accept != null) {
    const types = accept?.split(/,| |, /);
    if (!types?.includes(file.type)) {
      notify.error.t('projects.project.uploadFile.invalidType');
      return false;
    }
  }

  return true;
}

type AttachedExcelType = {
  files: File[] | null;
  store: (file: File) => void;
  accept: string;
  remove: (file: File) => void;
};

export function AttachExcel(props: AttachedExcelType) {
  const { store, files, remove, accept } = props;
  const inputRef = useRef<HTMLInputElement | null>(null);
  const { t } = useTranslation();

  async function upload(file: File) {
    const validatedFile = validate(file, accept) ? file : null;
    return validatedFile && store(validatedFile);
  }

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    upload(event?.target.files?.[0]!);
  }

  function openDialog() {
    inputRef.current!.click();
  }

  return (
    <>
      <div className={classNames(classes.attachExcelWrapper, classes.clickable)} onClick={openDialog}>
        <input
          ref={inputRef}
          accept={accept}
          style={{ height: 0, width: 0 }}
          value=""
          onChange={handleChange}
          type="file"
        />
        <div className={classes.btn}>
          <UploadOutlined />
          <Typography.Text>{t('attach.excel.btnText')}</Typography.Text>
        </div>
      </div>
      {files?.length ? (
        <div className={classes.attachedFilesWrapper}>
          <AttachedExcel files={files} remove={remove} />
        </div>
      ) : null}
    </>
  );
}
